import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom'
import { checkEmpty, getStorageJson, getStorage } from '../helpers/utility';
import { Row } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { LOGIN_PAGE } from '../helpers/constants';


const AuthProtectedRoute = () => {
  let navigate = useNavigate();
  let userid = getStorage('userid');
  let login_info = getStorage('login_info');

  useEffect(() => {
    if (checkEmpty(userid) || checkEmpty(login_info)) {
      navigate(LOGIN_PAGE);
    }
  }, [navigate, userid, login_info]);


  if (checkEmpty(userid) || checkEmpty(login_info)) {
     navigate(LOGIN_PAGE);
    return (
      <div>
        <Row>
              <div className="main-error-wrapper wrapper-1 page page-h">
                <h1 className="">401<span className="tx-20">Unauthorized</span></h1>
                <h2 className="">Your session has expired.</h2>
                <h6 className="">Please login to continue.</h6><Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}${LOGIN_PAGE}`}>Login now</Link>
              </div>
          </Row>
        </div>
    )
  }

  // returns child route elements
  return <Outlet />
}

export default AuthProtectedRoute